import { useParams } from 'react-router-dom'
import { getReport } from '../api/reader-api'
import { useQuery } from 'react-query'
import { useEffect } from 'react'
import { toast } from 'react-toastify'

const getData = async (
  id?: string,
  date?: string,
  type?: string
): Promise<string> => {
  if (!id) {
    throw new Error('Invalid id')
  }

  if (!type) {
    throw new Error('Invalid type')
  }

  const reportDate = new Date(date as string)
  if (Number.isNaN(reportDate.getTime())) {
    throw new Error('Invalid date')
  }

  return getReport(id, reportDate, type)
}

const ReaderReport = () => {
  const params = useParams()

  const { isError, data, error } = useQuery({
    queryKey: ['report', params.id, params.data, params.type],
    queryFn: () => getData(params.id, params.date, params.type),
  })

  useEffect(() => {
    if (isError && error instanceof Error) {
      toast.error(error.message)
    }
  }, [isError, error])

  return <pre className='text-xs break-normal'>{data}</pre>
}

export default ReaderReport
